import { createFileRoute } from "@tanstack/react-router";
import { AutomationView } from "@/components/views";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createFileRoute("/$workspaceId/automations/$channelId")({
	component: RouteComponent,
});

function RouteComponent() {
	const { workspaceId, channelId } = Route.useParams();
	const { session, currentWorkspace } =
		Route.useRouteContext() as RouterAppContext;
	
	return (
		<AutomationView
			workspaceId={workspaceId}
			channelId={channelId}
			session={session}
			currentWorkspace={currentWorkspace}
		/>
	);
}
